<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="aunote"> </p>
<p class="tnis"><span class="epub-b">Author’s Note:</span> Where indicated with an asterisk (*), pseudonyms have been used.</p>
<p class="tni"><span class="epub-b">Editor’s Note:</span> In the world of professional crime solving, the proper terminology is “bloodspatter.” However, for the purposes of readability in this book, the term has been broken into two separate words and appears throughout the text as “blood spatter.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authors.vue?dfb881a4